const util = {
  addCookie: function (name, value, options) {
    if (arguments.length > 1 && name !== null) {
      if (options === null) {
        options = {};
      }
      if (value === null) {
        options.expires = -1;
      }
      if (typeof options.expires === "number") {
        let time = options.expires;
        let expires = options.expires = new Date();
        expires.setTime(expires.getTime() + time * 1000);
      }
      document.cookie = encodeURIComponent(String(name)) + "=" + encodeURIComponent(String(value)) + (options.expires ? "; expires=" + options.expires.toUTCString() : "") + (options.path ? "; path=" + options.path : "") + (options.domain ? "; domain=" + options.domain : "") + (options.secure ? "; secure" : "");
    }
  },
  getCookie: function (name) {
    if (name !== null) {
      let value = new RegExp("(?:^|; )" + encodeURIComponent(String(name)) + "=([^;]*)").exec(document.cookie);
      return value ? decodeURIComponent(value[1]) : null;
    }
  },
  removeCookie: function (name, options) {
    this.addCookie(name, null, options);
  },
  addDefaultCookie: function (name, value) {
    this.addCookie(name, value, {path: "/", expires: 2 * 3600})
  },
  numDouble(num) {
    if (num >= 0 && num < 10) {
      return '0' + num
    }
    return num
  },
  dateArr(dataStr) {
    /*2018-05-30 00:00:00=>["2018", "04", "30", "00", "00", "00"]*/
    let arr = dataStr.replace(/-/g, ':').replace(' ', ':').split(':');
    arr[1]--;
    return new Date(...arr)
  },
  dateStr(date, showTime = false) {
    /*Date=>yyyy-mm-dd hh:mm:ss*/
    if (date instanceof Date && !isNaN(date.getTime())) {
      let arr = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
      if (showTime) {
        arr = arr.concat([date.getHours(), date.getMinutes(), date.getSeconds()])
      }
      arr = arr.map((x) => this.numDouble(x))
      let str = `${arr[0]}-${arr[1]}-${arr[2]}`
      if (showTime) {
        str += ` ${arr[3]}:${arr[4]}:${arr[5]}`
      }
      return str
    }
  },
  getUrlParam: function (paramName) {
    var reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (r != null) return unescape(r[2]);
    return null; //返回参数值
  },
  dateFormat(date) {
    let cn = date.split('-');
    let en = date.split('/');
    if (cn.length === 3) {
      return `${cn[1]}/${cn[2]}/${cn[0]}`
    } else if (en.length === 3) {
      return `${en[2]}-${en[0]}-${en[1]}`
    }
    return date
  },
  DAY: 86400000
}
export default util
